import React from "react";
import { Text } from "@bookingcom/bui-react";
import styles from "./BlackFridayCountdown.module.css";
import { useI18n, t } from "@bookingcom/lingojs-react";
import { useCountdown } from "./useCountdown";

// Wed, Dec 3rd at 10 AM CET = 09:00 UTC
const COUNTDOWN_TARGET_DATE = new Date("2025-12-03T09:00:00Z");

const BlackFridayCountdown: React.FC = () => {
  const countdown = useCountdown(COUNTDOWN_TARGET_DATE);
  const i18n = useI18n();

  if (countdown.isExpired) {
    return null;
  }

  return (
    <Text variant="featured_3" color="brand_genius_secondary" className={styles.countdown}>
      {i18n.trans(
        t("deals_blackfriday25_www_index_hero_variable_countdown_banner", {
          variables: { num_days: countdown.days.toString() },
          num_exception: countdown.days
        })
      )}
    </Text>
  );
};

export default BlackFridayCountdown;
